'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
var button = require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
var useRtl = require('../../../../hooks/use-rtl.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../atoms/icon/font-icon/font-icon.js');
require('react-transition-group');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('react-laag');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('@brandfolder/utilities');
require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
require('../../../atoms/button/icon-button/icon-button.js');
var standardButton = require('../../../atoms/button/standard-button/standard-button.js');
require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
require('../../../atoms/heading/standard-heading/standard-heading.js');
require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
require('../../../atoms/text/help-text/help-text.js');
require('../../../atoms/text/standard-text/standard-text.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledNextPreviousPagination = (props)=>{
    const { buttonProps , disabled , initial , labels ={
        nextLabel: '',
        previousLabel: ''
    } , loading , nextDisabled , onPageChange , previousDisabled , total , ...otherProps } = props;
    const { nextLabel , previousLabel  } = labels;
    const { isRtl  } = useRtl.useRtl();
    const [current, setCurrent] = React.useState(initial || 1);
    const [iconNext, setIconNext] = React.useState(fontIcon.FontIcons.ArrowRight);
    const [iconPrevious, setIconPrevious] = React.useState(fontIcon.FontIcons.ArrowLeft);
    const isCurrentFirst = current === 1;
    const isCurrentLast = current === total;
    const isDisabled = disabled || loading;
    React.useEffect(()=>{
        if (isRtl) {
            setIconNext(fontIcon.FontIcons.ArrowLeft);
            setIconPrevious(fontIcon.FontIcons.ArrowRight);
        } else {
            setIconNext(fontIcon.FontIcons.ArrowRight);
            setIconPrevious(fontIcon.FontIcons.ArrowLeft);
        }
    }, [
        isRtl
    ]);
    const onPage = (page)=>{
        setCurrent(page);
        onPageChange(page);
    };
    const renderNextPrevious = (type)=>{
        const disablePrevious = type === 'previous' && (previousDisabled || isCurrentFirst);
        const disableNext = type === 'next' && (nextDisabled || isCurrentLast);
        const disableNextPrevious = isDisabled || disableNext || disablePrevious;
        const startIcon = type === 'previous' ? iconPrevious : undefined;
        const endIcon = type === 'next' ? iconNext : undefined;
        const label = type === 'next' ? nextLabel : previousLabel;
        const page = type === 'next' ? current + 1 : current - 1;
        return /*#__PURE__*/ React__default.default.createElement(standardButton.StandardButton, _extends({}, buttonProps, {
            className: classnames__default.default({
                [`bf-pagination__${type}`]: true,
                [`bf-pagination__${type}--disabled`]: disableNextPrevious,
                [`${buttonProps?.className}`]: !!buttonProps?.className
            }),
            disabled: disableNextPrevious,
            startIcon: startIcon,
            endIcon: endIcon,
            look: buttonProps?.look || button.ButtonLooks.Default,
            onClick: disableNextPrevious ? undefined : ()=>onPage(page),
            onKeyUp: (e)=>{
                if (e.key === 'Enter' && !disableNextPrevious) {
                    onPage(page);
                }
            }
        }), label);
    };
    return /*#__PURE__*/ React__default.default.createElement("div", _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-pagination': true,
            'bf-pagination__next-previous': true,
            'bf-pagination__next-previous--disabled': disabled,
            [`${otherProps?.className}`]: !!otherProps?.className
        })
    }), renderNextPrevious('previous'), renderNextPrevious('next'));
};
const StyledNextPreviousPagination = styled__default.default(UnstyledNextPreviousPagination)`
  align-items: center;
  display: flex;
`;
/**
 * Pagination allows a user to move between pages of content such as search results.
 * Note that this pagination component uses `<button>` tags (it does not use `<a>` tags to change the URL).
 *
 * This simplified variant is used when the consumer is unable to reliably provide a total value or
 * does not want the user to be able to select specific pages. For example, use this variant when consuming
 * an API that uses [cursor pagination](https://jsonapi.org/profiles/ethanresnick/cursor-pagination/).
 *
 * https://developer.mozilla.org/en-US/docs/Web/CSS/Layout_cookbook/Pagination
 *
 *
 * @param props NextPreviousPaginationProps
 * @returns FunctionComponent<NextPreviousPaginationProps>
 */ const NextPreviousPagination = (props)=>{
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(StyledNextPreviousPagination, _extends({}, props)));
};

exports.NextPreviousPagination = NextPreviousPagination;
//# sourceMappingURL=next-previous-pagination.js.map
